// extracted by mini-css-extract-plugin
module.exports = {"Index":"IndexTemplate_Index__OIp2d","Index__PurchasesArea":"IndexTemplate_Index__PurchasesArea__KiiLD","Index__PurchasesContent":"IndexTemplate_Index__PurchasesContent__PtBNx"};